/**
 * Owl Carousel Slider
 */



export default function HWY_Slider() {

	const selectors = {
		carousel: ".owl-carousel"
	};

	this.init = () => {
		createCarousels();
	};

	const createCarousels = () => {
		jQuery(document).ready(function($) {
			if ($(selectors.carousel).length) {
				$(selectors.carousel).each(function () {
					const el = $(this);
					const autoScroll = el.data("scroll") ? el.data("scroll") : false;
					const numbers = el.data("numbers") ? el.data("numbers") : 1;
					const margin = el.data("margin") ? el.data("margin") : 0;
					const stage = el.data("stage") ? el.data("stage") : 0;

					el.owlCarousel({
						autoplay: autoScroll,
						autoplayTimeout: 7000,
						dots: false,
						responsive: {
							0: {
								items: 1
							},
							1024: {
								items: numbers
							}
						},
						loop: false,
						margin: margin,
						nav: true,
						navText: [
							'<span class="icon icon-arrow-left"></span>',
							'<span class="icon icon-arrow-right"></span>',
						],
						smartSpeed: 700,
						stagePadding : stage,
					});
				})
			}
		});
	}

}
